module.exports = __webpack_public_path__ + "img/AnnualMeeting2014ParkingArea_1.d08e720c.png";